import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const SectorSchema = (onlyRead = false) => {
  const RealSectorSchema = () =>
    yup.object({
      iD_Sector: yup.number().label(i18n2._('ID')),
      name: yup
        .string()
        .required(i18n2._('Este campo es obligatorio'))
        .max(100)
        .label(i18n2._('Sector')),
      resp_Employee_Nr: yup
        .number()
        .nullable(true)
        .label(i18n2._('Colaborador responsable')),
      active: yup.number().label(i18n2._('Activo en')),
      management: yup
        .string()
        .length(2)
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('Gerencia')),
      revision: yup.number().label(i18n2._('Revision')),
      reason: yup
        .string()
        .max(255)
        .required(i18n2._('Este campo es obligatorio'))
        .label(i18n2._('Motivo')),
      updateDate: yup.date().label(i18n2._('Fecha de actualizacion')),
      updatedBy: yup.string().label(i18n2._('Actualizado por')),
      deleted: yup.boolean().label(i18n2._('Eliminado')),
    });
  const readOnlySchema = () =>
    yup.object({
      totalPending: yup.number().label(i18n2._('Capacitaciones pendientes')),
    });

  return onlyRead === false
    ? RealSectorSchema()
    : readOnlySchema().concat(RealSectorSchema());
};
